import '@babel/polyfill';
import React, {Fragment} from 'react'
import { WithWindowHeightStyle, px } from "../../HOCs/WithWindowHeightStyle"
import { compose, setDisplayName } from "recompose"
import { connect } from "react-redux"
import {onSetBaseParams, getBookInfo, setBookInfo, setSampleMode, setBookUrl} from '../../actions/reader'
import { getLocaleString } from '../../locale/index'
import { cond, always, equals, T } from "ramda";

import { Header } from './components/Header/Header'
import { Footer } from './components/Footer/Footer'
import { Loading } from '../Shared/Loading/Loading'
import { EpubReader } from '../Formats/EpubReader/EpubReader'
import { PdfReader } from '../Formats/PdfReader/PdfReader'
import { Fb2Reader } from '../Formats/Fb2Reader/Fb2Reader'
import {OtherReader} from "../Formats/OtherReader/OtherReader";

import './Reader.css'
import {ModalContent} from "../../../src/components/Shared/ModalContent/ModalContent";
import {Modal} from "../../../src/components/Shared/Modal/Modal";
import { getCloudUser, goToCloud, isIE } from "../../utilities/utilities";
import ifElse from "ramda/es/ifElse";
import {createSocketClient, getClientId} from "../../socket";


export const modalStyles = {
  height: 'auto',
  overflow: 'hidden',
  width: '500px',
  top: '10vh',
  textAlign: 'center'
}

export const modalStylesMobile = {
  height: 'auto',
  overflow: 'hidden',
  width: '90vw',
  top: '2vh',
  textAlign: 'center'
}

const mapStateToProps = (state) => ({
  bookId: state.reader.bookId,
  bookReady: state.reader.bookReady,
  bookLoadingProgress: state.reader.bookLoadingProgress,
  bookInfo: state.reader.bookInfo,
  bookData: state.reader.book,
  activeError: state.privacyPolicy.activeError,
  language: state.userData.language,
  highlights: state.reader.highlights,
  isSampleMode: state.reader.isSampleMode
})

const mapDispatchToProps = (dispatch) => ({
  onSetBaseParams: (params, path) => dispatch(onSetBaseParams(params, path)),
  getBookInfo: (fast_hash) => dispatch(getBookInfo(fast_hash)),
  setBookInfo: (book) => dispatch(setBookInfo(book)),
  setSampleMode: (status) => dispatch(setSampleMode(status)),
  setBookUrl: (url) => dispatch(setBookUrl(url))
})

export const enhance = compose(
  setDisplayName('PBCloud Reader'),
  connect(mapStateToProps, mapDispatchToProps)
)

const RenderFormatComponent = ({ format }) => cond([
  [equals('epub'), always(<EpubReader />)],
  [equals('pdf'), always(<PdfReader />)],
  [equals('fb2') || equals('fb2.zip'), always(<Fb2Reader />)],
  [equals('mobi'), always(<OtherReader />)],
  [equals('docx'), always(<OtherReader />)],
  [T, always(null)]
])(format.toLowerCase())

const WaitingStatus = ({bookInfo: {status, format, error, errorMessage}, activeError, isReady}) => ifElse(
  equals(false),
  always(<Loading active={true}/>),
  () => cond([
    [equals('failed') || equals('error') || equals('processing'), always(<Modal>
      <ModalContent styles={ window.innerWidth > 768 ? modalStyles : modalStylesMobile } active={activeError} loading={false} onClose={goToCloud}>
        <p>{errorMessage ? errorMessage : getLocaleString('reader.errorInfo')}</p>
        {error ? <p>{error}</p> : ''}
        <button className="Button" onClick={() => goToCloud()}>{getLocaleString('reader.closeReaderBtn')}</button>
      </ModalContent>
    </Modal>)],
    [equals('ready'), always(<RenderFormatComponent format={format}/>)],
    [T, always(<Loading active={true}/>)]
  ])(status)
)(isReady)

export class View extends React.Component {
  getUrlParams(search) {
    const hashes = search.slice(search.indexOf('?') + 1).split('&')
    const params = {}
    hashes.map(hash => {
      const [key, val] = hash.split('=')
      params[key] = decodeURIComponent(val)
      return hash
    })
    return params
  }

  checkBookUrl(url) {
    return url.indexOf('pocketbook.') > -1 || url.indexOf('localhost:3232') > -1
  }

  componentDidMount () {
    const { props: {setSampleMode, setBookUrl, onSetBaseParams, getBookInfo, setBookInfo }} = this
    let search = this.props.location.search
    let searchObj = this.getUrlParams(search)
    let isSampleMode = false
    if (searchObj.href && this.checkBookUrl(searchObj.href)) {
      isSampleMode = true
      setSampleMode(isSampleMode)
      setBookUrl(searchObj.href)
    }

    if (!isSampleMode) {
      getCloudUser(search, onSetBaseParams)

      let clientID = getClientId()
      let socket = createSocketClient(clientID)

      socket.addEventListener('message', (e) => {
        let msg = JSON.parse(e.data)

        if (msg.action === 'read') {
          let data = msg.data
          let status = data.status
          if (status === 'done' && data.new_fast_hash) {
            getBookInfo(data.new_fast_hash)
          } else if (status === 'failed' || status === 'error') {
            setBookInfo(msg)
          }
        }
      })
    }
  }

  render() {
    const {props: { bookReady, bookLoadingProgress, bookInfo, activeError, highlights, isSampleMode, bookInfo: {format, status}}} = this

    return (
      <WithWindowHeightStyle render={({height}) => (
        <section className="Reader" style={{minHeight: px(height), width: '100%'}}>
          <Header />
          <main id="Reader__content" className={`Reader__content${isIE() ? ' ie-browser' : ''}`}>
            {!isSampleMode ? <div className="bookTitle mobile">{bookInfo.title}</div> : ''}
            {isSampleMode ?
              <Fragment>
                <EpubReader />
                <Loading active={!bookReady}
                         description={getLocaleString('reader.loadingBook') + ' ' + bookLoadingProgress + '%'}/>
              </Fragment> :
              <Fragment>
                <WaitingStatus bookInfo={bookInfo} bookReady={bookReady} bookLoadingProgress={bookLoadingProgress}
                               activeError={activeError} isReady={highlights ? highlights : status}/>
                <Loading active={!bookReady && status === 'ready'}
                         description={format ? getLocaleString('reader.loadingBook') + ' ' + bookLoadingProgress + '%' : ''}/>
              </Fragment>
            }
          </main>
          <Footer />
        </section>
      )} />
    )
  }
}

export const Reader = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/Reader.js